import { Button, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";

import ModalContent from "../components/modal/ModalContent";
import { SharedModalProps } from "../components/modal/ModalContextProvider";

const CompensationSuccessModal = ({ handleClose }: SharedModalProps) => {
  return (
    <ModalContent label="Gelukt!">
      <Typography>
        Je aanvraag is ingediend. Je ontvangt een e-mail als iemand hem
        accepteert.
      </Typography>
      <Stack direction="row" justifyContent="end">
        <Button
          sx={{ margin: "1em" }}
          type="button"
          variant="contained"
          onClick={handleClose}
        >
          Sluiten
        </Button>
      </Stack>
    </ModalContent>
  );
};

export default CompensationSuccessModal;
